<app-header></app-header>
<app-sidenav>
    <app-masquerade-header></app-masquerade-header>
    <div
        id="content"
        class="relative"
        [class.h-full]="!isMasqueraded()"
        [class.h-full-adjusted-for-masquerade-header]="isMasqueraded()"
        [class.pointer-events-none]="loading$ | async"
    >
        @if (loading$ | async) {
            <app-loading></app-loading>
        }

        <div class="flex">
            <div class="left-content-wrapper">
                <app-order-details-action-bar></app-order-details-action-bar>
                <div class="p-4 mt-3 mb-10">
                    <router-outlet></router-outlet>
                </div>
            </div>
        </div>
    </div>
</app-sidenav>
